import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  Optional,
  Injectable,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { GSBaseControl } from './gs.base.control';
import { FormAutocompleteProperty } from '../entity/form/formAutocomplete.property';
import { Item } from '../entity/entities';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { debounceTime, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { from, Observable, Subject } from 'rxjs';
import { UserJournalClient } from '../../client/userJournal.client';

@Component({
  selector: 'gs-user-autocomplete',
  templateUrl: './gs.userAutocomplete.control.html',
})
@Injectable()
export class GSUserAutoCompleteControl
  extends GSBaseControl
  implements OnInit, OnDestroy, AfterViewInit
{
 //#region -------Properties
 

  get field() {
    return this.property.field ? this.property.field : undefined;
  }
  suggestions$: Observable<any>;
  private unsubscribe$ = new Subject<void>();
  results = [];
  @ViewChild('filterInput') filterInput;
  //#endregion

  //#region -------Constructor
  constructor(
    @Optional()
    @Inject(FormAutocompleteProperty)
    prop: FormAutocompleteProperty,
    @Optional() @Inject(Item) item: Item,
    private changeDr: ChangeDetectorRef,
    private element: ElementRef,
    private userJournalClient: UserJournalClient,
  ) {
    super(changeDr);
    this.property = prop;
    this.item = item;
  }
  //#endregion

  //#region -------NG Eents
  ngOnInit() {
    //this.element
  }
  ngAfterViewInit(): void {
    if (this.filterInput != null && this.filterInput.el != null) {
      this.suggestions$ = fromEvent(
        this.filterInput.el.nativeElement,
        'keyup'
      ).pipe(
        debounceTime(500),
        map((event) => (<any>event).target.value),
        switchMap((filter) =>
          from(this.userJournalClient.userJournalUsersSearch(null, filter))
        ),
        tap((response) => {
           response?.result?.forEach(
            (x) =>
            (x.SelectedLabel =
              x.FirstName +
              ' ' +
              x.LastName +
              ' | Username: ' +
              x.UserName +
              ' | Code: ' +
              x.Code)
          )
        }),
        map((response) => {
          return response?.result;
        }),
        takeUntil(this.unsubscribe$)
      );
    }
  }

  ngOnDestroy() {}
  //#endregion

  //#region -------UI Events

  select(e) {
    //this.property.select.emit(e);
    if (!e || e == '') {
      this.property.complete.emit({
        value: e,
        property: this.property,
        item: this.item,
      });    
    }
    //if (this.property.setValueWhenTyping)
   
    this.data[this.name] = e;
    this.item.reCheckDirty();
    this.onChange.emit({
      propertyName: this.name,
      newValue: this.value,
      event: e,
      item: this.item,
      property: this.property,
      type: 'select'
    });
  }

  complete(e) {
    this.property.complete.emit({
      value: e,
      property: this.property,
      item: this.item
    });
  }

 

  onBlur(e) {
    this.property.onBlur.emit({
      value: e,
      property: this.property,
      item: this.item,
    });
  }

  changeAutocomplete(e) {

    if ((typeof e) == 'string') {
      this.data[this.name] = undefined;
    }

    if (!e || e == '') {
      this.property.complete.emit({
        value: e,
        property: this.property,
        item: this.item,
      });
     
    }
    if (this.property.setValueWhenTyping) this.data[this.name] = e;
    this.item.reCheckDirty();
    this.onChange.emit({
      propertyName: this.name,
      newValue: this.value,
      event: e,
      item: this.item,
      property: this.property,
      type: (typeof e) == 'string'?'change':'select'
    });
  }

  //#endregion

  //#region -------Private
  //#endregion
}
